import { Component, input, ViewEncapsulation } from '@angular/core';

import { ImageComponent } from '@valk-nx/components/ui-image/src/lib/image.component';
import { Sizes } from '@valk-nx/components/ui-image/src/lib/image.interface';
import { LinkComponent } from '@valk-nx/components/ui-link/src/lib/link';
import { SVG_ICON_IMPORTS } from '@valk-nx/helpers/lib/svg-unique-ids/svg-unique-ids.directive';

import type { ItemSlide } from '../slider.interface';

@Component({
	encapsulation: ViewEncapsulation.None,
	imports: [ImageComponent, LinkComponent, SVG_ICON_IMPORTS],
	selector: 'vp-slide',
	templateUrl: './slide.html',
})
export class SlideComponent {
	readonly item = input.required<ItemSlide>();

	protected readonly sizes = Sizes;
}
